import { action as apiAction } from 'api/Api'
import {
  setDueDate as setCardDueDate
} from '../redux/cards'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  id: number
  dueDate: number
}

export default (payload: Payload) => async dispatch => {
  const { id, dueDate } = payload

  const optimisticAction = optimisticDispatch(dispatch, setCardDueDate({
    id,
    dueDate
  }))

  try {
    await apiAction('SetDueDate', {
      timestamp: dueDate,
      cardId: id
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    throw error
  }
}
